import type { FC } from 'react';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDownOutlined';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUpOutlined';
import { IconButton } from '@mui/material';

import { GRID_AREA_ARROW } from '../UserSelector.constants';

interface SwitcherProps {
  menuAnchorEl: HTMLDivElement | null;
  shouldShowAccountSwitcher: boolean;
}

export const Switcher: FC<SwitcherProps> = ({ menuAnchorEl, shouldShowAccountSwitcher }) => {
  if (!shouldShowAccountSwitcher) return null;

  return (
    <IconButton sx={{ gridArea: GRID_AREA_ARROW }}>
      {menuAnchorEl ? <ArrowDropUpIcon color='action' /> : <ArrowDropDownIcon color='action' />}
    </IconButton>
  );
};
